import {logger} from '../../../utils/logging/logger'
import {warnServerEnvironment} from '../logging/server-warning'

/**
 * Remove an item from local or session storage in a safe way, logging an
 * error when the window object does not exist
 * @param storageOption - the storage to remove the item from
 * @param param - the chosen parameter to remove from the storage
 * @param errorString - the error message to log when it fails
 */
export const safelyRemoveStorageItem = (
  storageOption:
    | typeof localStorage
    | typeof sessionStorage
    | 'localStorage'
    | 'sessionStorage',
  param: string,
  errorString?: string
): void => {
  if (typeof window === 'undefined') {
    warnServerEnvironment(`remove ${storageOption}.${param}`)
    return undefined
  }
  try {
    const storage =
      typeof storageOption === 'string' ? window[storageOption] : storageOption
    storage.removeItem(param)
  } catch (err) {
    logger.error('safelyRemoveStorageItem:', {errorString, err})
  }
}
